import { render } from "./BatterVisitView.vue?vue&type=template&id=1025c81e&scoped=true"
import script from "./BatterVisitView.vue?vue&type=script&lang=js"
export * from "./BatterVisitView.vue?vue&type=script&lang=js"

import "./BatterVisitView.vue?vue&type=style&index=0&id=1025c81e&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1025c81e"]])

export default __exports__